import { IconX, type TablerIconsProps } from '@tabler/icons-react';
import type { ComponentType } from 'react';

import { Text } from '~/domains/design-system/Text';
import { Button } from '~/domains/design-system/Button';

import useStyles from './MessageBanner.styles';

// eslint-disable-next-line no-restricted-syntax
export enum BannerType {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  DEFAULT = 'default'
}

type MessageBannerProps = {
  type: BannerType;
  Icon?: ComponentType<TablerIconsProps>;
  title?: string;
  message?: string;
  children?: React.ReactNode;
  hasShadow?: boolean;
  onClose?: () => void;
};

function MessageBanner({
  type,
  Icon,
  title,
  message,
  children,
  hasShadow = false,
  onClose,
}: MessageBannerProps) {
  const { classes, cx, theme } = useStyles();

  return <div className={cx(classes.banner, type, hasShadow && 'hasShadow')}>
    {Icon && <div className={classes.icon}>
      <Icon size={24} />
    </div>}
    <div className={classes.content}>
      {title && <Text variant="subhead-small" tag="div">
        {title}
      </Text>}
      {message && <Text variant="body-medium" tag="div">
        {message}
      </Text>}
      {children}
    </div>
      {onClose && <Button
        onClick={onClose}
        size="small-icon"
        variant="tertiary-fill"
        style={{
          minWidth: theme.other.spacing._32,
          height: theme.other.spacing._32,
          borderRadius: theme.other.spacing._32,
        }}
      >
        <IconX size={20} stroke={1.5} color="#101113" />
      </Button>
    }
  </div>;
}


export default MessageBanner;
